import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { loginUser } from "../redux/slices/authSlice"
import AuthLayout from "../components/AuthLayout"


import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LoginPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth)

  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  })

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(loginUser({ username: formData.username, password: formData.password }))
  }

  useEffect(() => {
    if (auth.status === "succeeded") {
      toast.success("Login successful!");
      navigate("/dashboard");
    } else if (auth.status === "failed") {
      let errorMsg = "Login failed";
      if (auth.error) {
        // 1. If detail key exists
        if (auth.error.detail) {
          errorMsg = auth.error.detail;
        }
        // 2. If non_field_errors exist
        else if (auth.error.non_field_errors && Array.isArray(auth.error.non_field_errors)) {
          errorMsg = auth.error.non_field_errors.join(" ");
        }
        // 3. If username field errors
        else if (auth.error.username) {
          errorMsg = Array.isArray(auth.error.username) 
            ? auth.error.username.join(" ") 
            : auth.error.username;
        }
        // 4. If password field errors
        else if (auth.error.password) {
          errorMsg = Array.isArray(auth.error.password) 
            ? auth.error.password.join(" ") 
            : auth.error.password;
        }
        // 5. Otherwise, combine all error values (covers any other shape)
        else if (typeof auth.error === "object") {
          errorMsg = Object.values(auth.error).flat().join(" ");
        }
      }
      toast.error(errorMsg);
    }
  }, [auth.status, auth.error, navigate]);
  

  return (
    <AuthLayout activeTab="login">
      <div className="welcome-message">
        <h3 className="text-center mb-4">Welcome back!</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="username" className="form-label text-muted">
            Username
          </label>
          <input
            type="text"
            className="form-control custom-input"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="password" className="form-label text-muted">
            Password
          </label>
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control custom-input"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <button
              type="button"
              className="btn btn-link position-absolute end-0 top-50 translate-middle-y pe-3"
              onClick={() => setShowPassword(!showPassword)}
              style={{ border: "none", background: "none", color: "rgb(33, 60, 122)" }}
            >
              <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </button>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="rememberMe"
              name="rememberMe"
              checked={formData.rememberMe}
              onChange={handleInputChange}
            />
            <label className="form-check-label text-muted" htmlFor="rememberMe">
              Remember Me
            </label>
          </div>
          <a href="/forgot-password" className="text-warning text-decoration-none">
            Forgot Password?
          </a>
        </div>

        <button type="submit" className="btn btn-primary w-100 custom-btn">
          Log In
        </button>
      </form>
    </AuthLayout>
  )
}

export default LoginPage
